import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { SIZE_GUIDE_TAB_ID } from 'settings/productV2';
import { tabContext } from 'contexts/tabContext';

import styles from './ProductSizeGuide.module.scss';

type Props = {
  className?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
};

/**
 * Product page of website. Contains details product data.
 */
export default function ProductSizeGuide({
  className,
  onClick,
}: Props): JSX.Element {
  const { t } = useTranslation();
  const { setIdTab, scrollToTabs } = useContext(tabContext);

  return (
    <div className={classnames(styles.link, className)}>
      <a
        onClick={event => {
          setIdTab(SIZE_GUIDE_TAB_ID);
          scrollToTabs(SIZE_GUIDE_TAB_ID);
          onClick?.(event);
        }}
      >
        <span>{t('LABEL_SIZE_GUIDE_MODAL')}</span>
      </a>
    </div>
  );
}
